/* Mutual Optical — PDP gallery: image counter (1 / N). Zoom is Dawn's hover magnify. */
(function () {
  function init() {
    var list = document.querySelector('.product__media-wrapper .product__media-list');
    if (!list) return;
    var items = list.querySelectorAll('.product__media-item');
    var total = items.length;
    if (!total || document.querySelector('.mo-gallery-counter')) return;

    var counter = document.createElement('div');
    counter.className = 'mo-gallery-counter';
    list.appendChild(counter);

    function activeIdx() {
      for (var i = 0; i < items.length; i++) { if (items[i].classList.contains('is-active')) return i; }
      var c = list.scrollLeft + list.clientWidth / 2;
      for (var j = 0; j < items.length; j++) {
        var it = items[j];
        if (it.offsetLeft <= c && (it.offsetLeft + it.offsetWidth) > c) return j;
      }
      return 0;
    }
    function update() { counter.textContent = (activeIdx() + 1) + ' / ' + total; }
    update();

    var mo = new MutationObserver(update);
    for (var i = 0; i < items.length; i++) mo.observe(items[i], { attributes: true, attributeFilter: ['class'] });
    var t = null;
    list.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 80); }, { passive: true });
    var thumbs = document.querySelectorAll('.product__media-wrapper .thumbnail');
    for (var k = 0; k < thumbs.length; k++) thumbs[k].addEventListener('click', function () { setTimeout(update, 130); });
  }

  /* Hover-to-zoom. Dawn's own "hover" zoom mode only magnifies after a click, so it is
     reimplemented here; the native lightbox stays for touch devices. */
  function initHoverZoom() {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var ZOOM = 2.2;

    if (!document.getElementById('mo-zoom-style')) {
      var st = document.createElement('style');
      st.id = 'mo-zoom-style';
      st.textContent =
        '.product__media-wrapper .product-media-container{cursor:zoom-in;}' +
        // Hover zoom replaces the badge as the affordance here; touch devices keep it.
        '.product__media-wrapper .product__media-icon{display:none!important;}' +
        '.product__media-wrapper .product__media{position:relative;}' +
        '.mo-zoom-lens{position:absolute;z-index:4;pointer-events:none;transform-origin:0 0;max-width:none;}';
      document.head.appendChild(st);
    }

    var boxes = document.querySelectorAll('.product__media-wrapper .product-media-container');
    for (var i = 0; i < boxes.length; i++) (function (box) {
      if (box.getAttribute('data-mo-zoom')) return;
      box.setAttribute('data-mo-zoom', '1');
      var media = box.querySelector('.product__media');
      var img = box.querySelector('img');
      if (!media || !img) return;
      var lens = null;

      // Painted area of an object-fit:contain image, relative to its own box.
      function area() {
        var cw = img.clientWidth, ch = img.clientHeight;
        var nr = (img.naturalWidth || 1) / (img.naturalHeight || 1);
        var w = cw, h = cw / nr;
        if (h > ch) { h = ch; w = ch * nr; }
        return { w: w, h: h, x: (cw - w) / 2, y: (ch - h) / 2 };
      }
      function show() {
        if (lens || !img.complete || !img.naturalWidth) return;
        var a = area();
        lens = document.createElement('img');
        lens.className = 'mo-zoom-lens';
        lens.src = (img.currentSrc || img.src).replace(/([?&]width=)\d+/, '$11946');
        lens.style.left = a.x + 'px'; lens.style.top = a.y + 'px';
        lens.style.width = a.w + 'px'; lens.style.height = a.h + 'px';
        media.appendChild(lens);
      }
      function move(e) {
        if (!lens) return;
        var a = area(), b = media.getBoundingClientRect();
        var px = Math.min(Math.max((e.clientX - b.left - a.x) / a.w, 0), 1);
        var py = Math.min(Math.max((e.clientY - b.top - a.y) / a.h, 0), 1);
        lens.style.transform = 'translate(' + (-px * a.w * (ZOOM - 1)) + 'px,' +
          (-py * a.h * (ZOOM - 1)) + 'px) scale(' + ZOOM + ')';
      }
      function hide() { if (lens) { lens.parentNode && lens.parentNode.removeChild(lens); lens = null; } }

      box.addEventListener('mouseenter', show);
      box.addEventListener('mousemove', function (e) { show(); move(e); });
      box.addEventListener('mouseleave', hide);
    })(boxes[i]);
  }
  function boot() { init(); initHoverZoom(); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
